import { useScript } from 'common/hooks/use-script';

interface UseLoadGoogleClientArgs {
  onLoad: () => void;
  onError?: (error: string) => void;
}

const GOOGLE_CLIENT_SCRIPT_SRC = 'https://accounts.google.com/gsi/client';

export const useLoadGoogleClient = ({ onLoad, onError }: UseLoadGoogleClientArgs) => {
  useScript({
    url: GOOGLE_CLIENT_SCRIPT_SRC,
    async: true,
    defer: true,
    onLoad,
    onError,
  });
};
